// ===== Packages =====

import styled                       from 'styled-components';

// ===== Constants =====

import {
    BODY_FONT_SIZE,
}                                   from '../../constants/generalConstants';
import FONT_TYPE                    from '../../constants/fontType';

const HEADER_HEIGHT = 90;

export const Container = styled.div`
    width: 100%;
    height: auto;
    min-height: 100vh;
    min-height: 100svh;
    min-height: 100dvh;
    background: ${({ theme }) => theme.color.white};
`;

export const TermsTextContainer = styled.div`
    position: relative;
    width: 100%;
    height: auto;
    min-height: 100vh;
    min-height: 100svh;
    min-height: 100dvh;
    padding: ${`${1.25 * BODY_FONT_SIZE}px ${1.875 * BODY_FONT_SIZE}px`};
    padding-top: ${`${HEADER_HEIGHT + 3.125 * BODY_FONT_SIZE}px`};
    padding-bottom: ${`${3.75 * BODY_FONT_SIZE}px`};
`;

interface TermsHeaderProps {
    color: string,
    isVisible: boolean,
    delay: number,
    enterDuration: number,
    marginTop?: boolean,
}
export const TermsHeader = styled.h2<TermsHeaderProps>`
    position: relative;
    top: ${({ isVisible }) => `${isVisible ? 0 : 2.5 * BODY_FONT_SIZE}px`};
    font-family: ${FONT_TYPE.PRESS_START};
    font-size: 1.25em;
    font-weight: 700;
    color: ${({ theme, color }) => color || theme.verascopeColor.purple200};
    line-height: 2em;
    width: 100%;
    margin: 0 auto;
    margin-top: ${({ marginTop }) => `${marginTop ? 4 * BODY_FONT_SIZE : 0}px`};
    text-align: center;
    opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
    pointer-events: none;
    transition: ${({
        enterDuration,
        delay,
        theme,
    }) => `
        top ${enterDuration}ms ${delay}ms ${theme.motion.overshoot},
        opacity ${enterDuration}ms ${delay}ms ${theme.motion.eagerEasing}
    `};

    ${({ theme }) => theme.mediaQuery.small} {
        font-size: 1.25em;
    }

    ${({ theme }) => theme.mediaQuery.extraSmall} {
        font-size: 1em;
    }
`;

interface TermsListProps {
    isNumbered?: boolean,
}
export const TermsList = styled.ul<TermsListProps>`
    margin: 0;
    padding: 0;
    list-style: ${({ isNumbered }) => (isNumbered ? 'decimal' : 'square')};
    overflow: hidden;
`;

interface TermsListItemProps {
    isVisible: boolean,
    delay: number,
    enterDuration: number,
}
export const TermsListItem = styled.li<TermsListItemProps>`
    font-family: ${FONT_TYPE.PRESS_START};
    font-size: 0.9em;
    font-weight: 400;
    color: ${({ theme }) => theme.verascopeColor.purple200};
    line-height: 2em;
    max-width: 50ch;
    margin: 0 auto;
    margin-top: 2em;
    opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
    pointer-events: none;
    transition: ${({
        enterDuration,
        delay,
        theme,
    }) => `
        top ${enterDuration}ms ${delay}ms ${theme.motion.overshoot},
        opacity ${enterDuration}ms ${delay}ms ${theme.motion.eagerEasing}
    `};

    ${({ theme }) => theme.mediaQuery.small} {
        font-size: 0.8em;
    }

    ${({ theme }) => theme.mediaQuery.extraSmall} {
        font-size: 0.7em;
    }
`;

interface TermsTextProps {
    isVisible: boolean,
    delay: number,
    enterDuration: number,
    marginTop?: boolean,
}
export const TermsText = styled.p<TermsTextProps>`
    position: relative;
    top: ${({ isVisible }) => `${isVisible ? 0 : 2.5 * BODY_FONT_SIZE}px`};
    font-family: ${FONT_TYPE.PRESS_START};
    font-size: 1em;
    font-weight: 400;
    color: ${({ theme }) => theme.verascopeColor.purple200};
    line-height: 2em;
    max-width: 50ch;
    margin: 0 auto;
    margin-top: ${({ marginTop }) => `${marginTop ? 2.5 * BODY_FONT_SIZE : 0}px`};
    opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
    pointer-events: none;
    transition: ${({
        enterDuration,
        delay,
        theme,
    }) => `
        top ${enterDuration}ms ${delay}ms ${theme.motion.overshoot},
        opacity ${enterDuration}ms ${delay}ms ${theme.motion.eagerEasing}
    `};

    ${({ theme }) => theme.mediaQuery.small} {
        font-size: 0.9em;
    }

    ${({ theme }) => theme.mediaQuery.extraSmall} {
        font-size: 0.8em;
    }
`;

interface ColorTextProps {
    color: string,
}
export const ColorText = styled.span<ColorTextProps>`
    color: ${({ color }) => color};
`;

interface AnchorProps {
    customCursorActive: boolean,
}
export const Anchor = styled.a<AnchorProps>`
    color: ${({ theme }) => theme.verascopeColor.orange200};
    cursor: ${({ customCursorActive }) => (customCursorActive ? 'none' : 'pointer')};
    pointer-events: auto;

    &:hover {
        color: ${({ theme }) => theme.verascopeColor.orange100};
        transform: scale(1.15);
    }
`;
